import './silenceConsole';
import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/globals.css';
import App from './App.js';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { initAdPixels } from './adPixels';
import { captureAttribution } from './utils/attribution';
import { initSiteEngagementTracking } from './utils/siteClickTracking';

// Meta Pixel + GA4 — no-op until REACT_APP_META_PIXEL_ID / REACT_APP_GA4_MEASUREMENT_ID are set.
initAdPixels();

// UTM/click-ID capture — no-op if the landing URL has no UTM params and no ad click ID.
captureAttribution();

// Site-wide click + scroll-depth tracking — one-time listener setup, covers every page.
initSiteEngagementTracking();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

